module.exports = __webpack_public_path__ + "img/hzfp18.6a67c2b5.png";